import React from 'react'
import { connect } from 'react-redux'
import { getJourney, selectJourney } from '../../../../../redux/modules/journey'
import Journey from '../components/Journey'
import {toJS} from '../../../../../util/ToJS'
import LoadingSwitch from '../../../../../core/components/loading-switch/LoadingSwitch'
import {PrimaryButton} from '../../../../../core/components/unilink/index'

const EmptyJourney = ({classNames}) => (
  <div className={classNames}>
    <div className='no-lessons'>
      <div className='no-lessons__container'>
        <h3>You haven't begun your journey yet.</h3>
        <span>Find a topic you would like to practice. Once you begin practicing, you'll see the topics you've practiced here.</span>
        <PrimaryButton className={`no-lessons__button`} to='/subjects'>
          View Subjects
        </PrimaryButton>
      </div>
    </div>
  </div>
)

class VisibleJourney extends React.PureComponent {

  componentDidMount() {

  }

  render() {
    const {didGetJourney, isFetching, recentSubjects, errorMessage, bucketedJourney, canLoadMore, getJourney} = this.props
    const classNames = [this.props.className, 'gridcontainer'].join(' ')
    let activeState = <div className={classNames} />
    let loadingState = <Journey className={classNames} loading />
    const isLoading = isFetching && !didGetJourney

    if (errorMessage) {
      activeState = <EmptyJourney classNames={classNames} />
    } else if (didGetJourney) {
      activeState = (
        <Journey
          className={classNames}
          bucketedJourney={bucketedJourney}
          recentSubjects={recentSubjects}
          canLoadMore={canLoadMore}
          loading={isFetching}
          showMore={() => getJourney(true)} />
      )
    } else if (!didGetJourney && !isFetching) {
      activeState = <EmptyJourney classNames={`${classNames} profile-empty`} />
    }
    return (
      <LoadingSwitch
        activeState={activeState}
        loadingState={loadingState}
        isLoading={isLoading}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    ...selectJourney(state),
    errorMessage: state.getIn(['journey','errorMessage']),
    isFetching: state.getIn(['journey','isFetching']),
    canLoadMore: state.getIn(['journey','totalNum']) > state.getIn(['journey','journey']).size
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getJourney: (nextPage=false) => dispatch(getJourney(nextPage))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(toJS(VisibleJourney))



// WEBPACK FOOTER //
// ./src/domains/home/logged-in-home/journey/containers/VisibleJourney.js